import { ShieldOffIcon } from "lucide-react";
import { useMe } from "@/api/me";
import { hasPermission } from "@/auth/permissions";
import { EmptyState } from "@/components/empty-state";
import { PageHeader } from "@/components/page-header";
import type { PortalSection } from "@/layout/nav";
import { PortalApprovalsPage, PortalInvoicesPage, PortalProjectsPage } from "@/portal/PortalPages";
import { PortalTicketsPage } from "@/portal/PortalTicketsPage";

const PAGES: Record<string, () => React.JSX.Element> = {
  tickets: PortalTicketsPage,
  approvals: PortalApprovalsPage,
  projects: PortalProjectsPage,
  invoices: PortalInvoicesPage,
};

export function PortalSectionPage({ section }: { section: PortalSection }) {
  const { data: me } = useMe();
  const allowed = !section.permission || hasPermission(me?.permissions, section.permission);
  const Page = PAGES[section.slug];

  if (allowed && Page) return <Page />;
  return (
    <>
      <PageHeader title={section.label} description={section.description} />
      <EmptyState
        icon={ShieldOffIcon}
        title="Not available for your account"
        description="Ask your organisation's Datanomy contact if you need access to financial information."
      />
    </>
  );
}
